import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';

import { TabPanelProps } from './TabPanel';

export const TabPanelStyled = styled(Box)<TabPanelProps>((props) => ({
  display: props.value !== props.index ? 'hidden' : 'initial',
}));
